/**
 * @auth 赖传峰
 * @date 2022/4/21
 */
import { useUserInfo } from '~/store/userInfo'
import qs from 'qs'
import { type ShareState } from '~/store/share'
import { DEEP_LINK_PREFIX } from '~/types/constants'
/**
 * 前端h5转存后成功后，调用客户端打开和播放的deeplink：
 * open:  pikpakapp://mypikpak.com/xpan/share_restore_h5?action=open&tab=0&parent_id=xxx&open_file_id=xxx
 * view:  pikpakapp://mypikpak.com/xpan/share_restore_h5?action=view&parent_id=xxx&file_ids=xxx,xxx,xxx
 * 参数：每个参数都要urlEncode，防止url被截断
 * action: "view" : 文件中查看，  "open" : 立即打开，当action为"open"时一定要添加&tab=0参数前往首页，否则可能不会播放
 * parent_id : 转存到哪个目录了，open和view都需要，用来同步子文件将新文件拉下来，文件中查看也是打开的此目录, open时也要传此值，否则本地数据库没有同步到数据也不会播放
 * open_file_id: 要打开哪个文件，open的时候使用
 * file_ids: 转存后新添加的文件id列表，用来高亮展示文件，以逗号分割，view的时候使用
 * @param action
 * @param parentId
 * @param fileIds
 */

type DeepLinkParams = Pick<ShareState['restoreResult'], 'parentId' | 'fileIds'>
export default {
  openFile(parentId: string, fileId: string) {
    const query = {
      action: 'open',
      tab: 0,
      parent_id: parentId,
      open_file_id: fileId,
      user_id: useUserInfo().userId,
    }

    return `${DEEP_LINK_PREFIX}/share_restore_h5?${qs.stringify(query)}` as const
  },
  viewFile({ parentId, fileIds }: DeepLinkParams) {
    const query = {
      action: 'view',
      parent_id: parentId,
      file_ids: fileIds?.join(),
      user_id: useUserInfo().userId,
    }
    return `${DEEP_LINK_PREFIX}/share_restore_h5?${qs.stringify(query)}` as const
  },
  share(shareId: string, sharePwd?: string) {
    return `pikpakapp://mypikpak.com/drive/share_watch?share_id=${shareId}&pass_code=${sharePwd||''}&from=web`
  }
}
